export default "<p>\r\n  products works!\r\n</p>\r\n";